import {axios} from "./axios"
const getComMsg =(data)=>{
    return  axios({
        method:"post",
        url:"/api/merchantServeFlow/getMerchantServeFlowInfo",
        data
    })
}

export {getComMsg}